import { faAlignLeft, faAlignRight, faCheck, faCopy } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useState } from "react"
import { useSelector } from "react-redux";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { darcula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { selectSettings } from "../features/settings/settingsSlice";

function ResponseCodeView({body, language, highlight, header}) {
  const {formatCode} = useSelector(selectSettings)

  const [isCopy, setIsCopy] = useState(false)
  const copyBtn = () =>{
    setIsCopy(true)
    navigator.clipboard.writeText(body)
    setTimeout(()=>{
      setIsCopy(false)
    }, 3000)
  }
  return (
    <>
    {highlight && formatCode ? 
    <div className="code-container">
   <div className="code-header">
    <p>{header  }</p>
   {!isCopy? <button  onClick={copyBtn}><FontAwesomeIcon icon={faCopy} /> Copy Code    </button>
     :<button><FontAwesomeIcon icon={faCheck} /> !Copied    </button> }
     </div>
      <SyntaxHighlighter wrapLongLines={true} wrapLines={true} language={language} style={darcula}>
      {body}
      </SyntaxHighlighter> </div>
      : 
      <textarea readOnly
                    className={`form__input form__input--ltr  form__input--body  `}
                    id="body"
                    name="body"
                    value={body}
                    
                />
    }
   
       
           
    </>
   
  )
}

export default ResponseCodeView